import { parseZone, type DatetimeType } from './datetime';
import { type Moment } from './moment-bridge';

// `HH:mm` — mirrors works/legacy/lib/date-helper's HUMAN_TIME_FORMAT. Inlined
// rather than imported because date-helper imports from this datetime package,
// so importing the constant here would create a circular dependency.
const HUMAN_TIME_FORMAT = 'HH:mm';

// Formats a datetime at its preserved wall-clock time. Records deliver ISO
// strings (run through parseZone to keep the baked-in offset); an already-
// hydrated dayjs/moment value (e.g. an antd v4 picker value) is formatted as-is
// — both expose an offset-preserving `.format`. The `Moment` overload is kept so
// a caller handing a hydrated picker value renders the same wall clock.
export function formatTimeZone(date: string | DatetimeType | Moment) {
  if (!date) {
    return date;
  }
  const value = typeof date === 'string' ? parseZone(date) : date;
  return value.format(HUMAN_TIME_FORMAT);
}
